import React from "react";
import { useTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { Playlist, getPlayList } from "../../services/ContentServices";
import {
  Box,
  Drawer,
  InputAdornment,
  TablePagination,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {
  AddFreeBriesHome,
  FreeBiesHome,
} from "../../services/ContentManagementService";
import { TableBodyPlayList } from "../../utils/ContentCardList";
import { useSnackbar } from "notistack";

interface DrawerFreebieManagementProps {
  open: boolean;
  onClose: () => void;
  position: 0 | 1 | 2 | 3;
  onUpdate: () => void;
}
const DrawerFreebieManagement: React.FC<DrawerFreebieManagementProps> = ({
  open,
  onClose,
  position,
  onUpdate,
}) => {
  const theme = useTheme();

  return (
    <>
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        sx={{
          "& .MuiDrawer-paper": {
            backgroundColor: theme.palette.background.paper,
            borderTopLeftRadius: theme.spacing(2),
            borderBottomLeftRadius: theme.spacing(2),
            width: "30%",
            height: "100vh",
            boxSizing: "border-box",
          },
        }}
      >
        <Box
          component="form"
          aria-label="Video List"
          sx={{
            display: "flex",
            backgroundColor: theme.palette.background.paper,
            flexDirection: "column",
            height: "100vh",
            maxHeight: "100vh",
            boxSizing: "border-box",
          }}
        >
          <PlayList position={position} reload={onUpdate} onClose={onClose} />
        </Box>
      </Drawer>
    </>
  );
};

export default DrawerFreebieManagement;

const PlayList = ({
  position,
  reload,
  onClose,
}: {
  position: 0 | 1 | 2 | 3;
  reload: () => void;
  onClose: () => void;
}) => {
  const theme = useTheme();
  const [loading, setLoading] = useState<boolean>(false);
  const [totalElements, setTotalElements] = useState<number>(0);
  const rowsPerPageOptions = [5, 15, 25];
  const [playlists, setPlaylists] = useState<Playlist[]>([]);
  const [rowsPerPage, setRowsPerPage] = useState<number>(rowsPerPageOptions[0]);
  const [page, setPage] = useState<number>(0);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    getPlayListContent();
  }, [page, rowsPerPage]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const getPlayListContent = async () => {
    setLoading(true);
    try {
      const response = await getPlayList({ page, size: rowsPerPage });
      setPlaylists(response.data.content);
      setTotalElements(response.data.totalElements);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleAddFreebies = async (id: string): Promise<number> => {
    const status = await AddFreeBriesHome({ playlistId: id, position });
    if (status == 200) {
      enqueueSnackbar("Successfully ! Freebies has been Added", {
        variant: "success",
      });
      reload();
      onClose();
      return 200;
    } else {
      enqueueSnackbar("Failed ! Freebies has not Added", {
        variant: "error",
      });
      return 401;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: theme.palette.background.paper,
        flexDirection: "column",
        height: "100vh",
        minHeight: "100vh",
        maxHeight: "100vh",
        padding: theme.spacing(1),
        boxSizing: "border-box",
      }}
    >
      {/* conflicts */}
      <Box
        mb={2}
        mt={2}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <TextField
          placeholder="Search by name"
          variant="outlined"
          size="small"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          marginBottom: theme.spacing(1),
          scrollbarWidth: "none",
        }}
      >
        <TableBodyPlayList
          drawer
          loading={loading}
          playlists={playlists}
          callBackchange={handleAddFreebies}
          //   selectedSubscription={selectedSubscription}
          //   onDataUpdate={onDataUpdate}
          //   storedPlayListIds={storedPlayListIds}
        />
      </Box>
      <Box sx={{ marginTop: "auto" }}>
        <TablePagination
          rowsPerPageOptions={rowsPerPageOptions}
          component="div"
          count={totalElements}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
    </Box>
  );
};
